import React, { Fragment } from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import AtIcon from 'src/assets/icons/at-sign.svg';
import LockIcon from 'src/assets/icons/lock.svg';
import { TextField } from 'src/components/TextField';

storiesOf('Form', module).add('TextField', () => (
  <Fragment>
    <PanelHeader>✉️ TextField</PanelHeader>
    <View>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField placeholder="Enter your name" />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField placeholder="Disabled" disabled />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField placeholder="0123 4567 8901 234" />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField value="Wrong value" error={true} clearButtonMode="always" />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField placeholder="Valid value" success={true} />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField icon={<AtIcon />} placeholder="Email" />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField icon={<LockIcon />} placeholder="Password" secureTextEntry={true} />
        </View>
      </PlatformPadding>
      <PlatformPadding vertical horizontal>
        <View>
          <TextField icon={<LockIcon />} placeholder="Disabled" secureTextEntry={true} disabled />
        </View>
      </PlatformPadding>
    </View>
  </Fragment>
));
